/**
 * Helpers for Arabic (ar-EG) localization: Eastern Arabic numerals and time formatting.
 */

const EASTERN_ARABIC = '٠١٢٣٤٥٦٧٨٩';

/**
 * Convert ASCII digits in a string to Eastern Arabic numerals (٠-٩).
 * @param {string} str - String that may contain 0-9 (e.g. "22", "6:45").
 * @returns {string}
 */
export function toEasternArabicNumerals(str) {
  if (str == null || str === '') return str;
  return String(str).replace(/[0-9]/g, d => EASTERN_ARABIC[parseInt(d, 10)]);
}

/**
 * Format 24h time "HH:mm" for display. For ar-EG uses Eastern Arabic numerals and ص/م.
 * @param {string} time24 - e.g. "18:45"
 * @param {string} locale - e.g. "ar-EG" or "en-GB"
 * @returns {string} e.g. "6:45 PM" or "٦:٤٥ م"
 */
export function formatTimeLocale(time24, locale) {
  if (!time24) return time24;
  const [h, m] = time24.split(':').map(Number);
  const hour12 = h === 0 ? 12 : h > 12 ? h - 12 : h;
  const minStr = String(m ?? 0).padStart(2, '0');
  const isAr = locale === 'ar-EG';
  if (isAr) {
    const period = h >= 12 ? 'م' : 'ص';
    const hourStr = toEasternArabicNumerals(String(hour12));
    const minAr = toEasternArabicNumerals(minStr);
    return `${hourStr}:${minAr} ${period}`;
  }
  const ampm = h >= 12 ? 'PM' : 'AM';
  return `${hour12}:${minStr} ${ampm}`;
}
